function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 0a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm2.39 4.31L7.629 6.573 5.365 4.31a.4.4 0 00-.565 0l-.114.114a.4.4 0 000 .565L6.95 7.252 4.686 9.515a.4.4 0 000 .565l.114.114a.4.4 0 00.565 0L7.628 7.93l2.263 2.263a.4.4 0 00.565 0l.114-.114a.4.4 0 000-.565L8.307 7.252l2.263-2.263a.4.4 0 000-.565l-.114-.114a.4.4 0 00-.565 0z",
  fill: "#54585D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.365 10.194L7.628 7.93l2.263 2.263a.4.4 0 00.565 0l.114-.114a.4.4 0 000-.565L8.307 7.252l2.263-2.263a.4.4 0 000-.565l-.114-.114a.4.4 0 00-.565 0L7.628 6.573 5.365 4.31a.4.4 0 00-.565 0l-.114.114a.4.4 0 000 .565L6.95 7.252 4.686 9.515a.4.4 0 000 .565l.114.114a.4.4 0 00.565 0z",
  fill: "#FFF"
}))));